import React from 'react';
import PropTypes from 'prop-types';
import Network from '../Network';

import Style from './ForgotPasswordSuccess.module.scss';

const ForgotPasswordSuccess = ({ language, network, onClose }) => {
  const {
    profileResetPw_emailPromptHeader: headerText,
    profileResetPw_emailPromptMessage: promptMessage,
    profileResetPw_emailPromptContinueButton: continueButtonText,
  } = language || {};
  return (
    <main className={Style.forgotPasswordSuccess}>
      <div className={Style.forgotPasswordSuccessContainer}>
        <div className={Style.wrap}>
          <div className={Style.secondaryHeader}>
            <Network network={network} />
          </div>
          <h1 className={Style.forgotPasswordSuccessHeaderText}>{headerText}</h1>
          <div className={Style.forgotPasswordSuccessText}>{promptMessage}</div>
        </div>
        <button className={Style.btnPrimary} autoFocus onClick={onClose}>
          {continueButtonText}
        </button>
      </div>
    </main>
  );
};

ForgotPasswordSuccess.defaultProps = {
  network: [],
};

ForgotPasswordSuccess.propTypes = {
  language: PropTypes.shape({
    profileResetPw_emailPromptContinueButton: PropTypes.string,
    profileResetPw_emailPromptHeader: PropTypes.string,
    profileResetPw_emailPromptMessage: PropTypes.string,
  }).isRequired,
  network: PropTypes.arrayOf(PropTypes.shape({})),
  onClose: PropTypes.func.isRequired,
};

export default ForgotPasswordSuccess;
